export const ALARM_HISTORY_DEFAULT_LIST_SORT = 'created_at';
export const ALERT_HISTORY_DEFAULT_LIST_SORT = 'time';
export const LIST_ORDER = 'DESC';
